module.exports = __webpack_public_path__ + "static/media/washer.6a6c6b55.svg";